<i18n src="./../../i18n/payment_form.json"></i18n>

<template>
    <div id="form-payment" class="row p-0 m-0 mt-payment no-gutters mt-3 pb-4">
        <div class="col-lg-12 mt-product-main-details p-4">
            <p class="font-weight-bold mt-fs-x-large pt-2" v-text="$t('title')"/>
        </div>

        <div v-if="Const.ACTIVE_PAYMENT_GATEWAY === 'payu'" class="row p-row ml-4 mr-4 p-2 m-1">
            <div class="col-auto p-checkbox align-content-center">
                <input id="payu" class="form-check-input" type="checkbox" :checked="paymentForm.method === 'payu'" v-on:change="changePaymentForm('payu')"/>
            </div>
            <div class="col">
                <img src="/assets/payu-logo.png" alt="payu" class="mr-4 ml-3" v-on:click="changePaymentForm('payu')">
                <label class="form-check-label" for="payu" v-text="$t('data.payu')"/>
            </div>
        </div>
        <div v-if="Const.ACTIVE_PAYMENT_GATEWAY === 'montonio'" class="row p-row ml-4 mr-4 p-2 m-1">
            <div class="col-auto p-checkbox align-content-center">
                <input id="montonio" class="form-check-input" type="checkbox" :checked="paymentForm.method === 'montonio'" v-on:change="changePaymentForm('montonio')"/>
            </div>
            <div class="col">
                <img src="/assets/montonio-logo.png" alt="montonio" class="mr-4 ml-3" v-on:click="changePaymentForm('montonio')">
                <label class="form-check-label" for="montonio" v-text="$t('data.montonio')"/>
            </div>
        </div>
        <div v-if="Const.ACTIVE_PAYMENT_GATEWAY === 'payu'" class="row p-row ml-4 mr-4 p-2 m-1">
            <div class="col-auto p-checkbox align-content-center">
                <input id="blik" class="form-check-input" type="checkbox" :checked="paymentForm.method === 'blik'" v-on:change="changePaymentForm('blik')"/>
            </div>
            <div class="col">
                <img src="/assets/blik-logo.png" alt="blik" class="mr-4 ml-3" v-on:click="changePaymentForm('blik')">
                <label class="form-check-label" for="blik" v-text="$t('data.blik')"/>
            </div>
        </div>
        <div class="row p-row ml-4 mr-4 p-2 m-1">
            <div class="col-auto p-checkbox align-content-center">
                <input id="creditCard" class="form-check-input" type="checkbox" :checked="paymentForm.method === 'creditCard'" v-on:change="changePaymentForm('creditCard')"/>
            </div>
            <div class="col">
                <img src="/assets/visa-mc-logo.png" alt="visa mc" class="mr-4 ml-3" v-on:click="changePaymentForm('creditCard')">
                <label class="form-check-label" for="creditCard" v-text="$t('data.creditCard')"/>
            </div>
        </div>
    </div>
</template>

<script>
    import {Const} from "@/main";

    export default {
        name: "PaymentForm",
        components: {},
        props: {
            paymentForm: {}
        },
        data () {
            return {
                locale: this.$i18n.locale,
            }
        },
        mounted() {
            if (Const.ACTIVE_PAYMENT_GATEWAY === 'montonio') {
              // eslint-disable-next-line no-console
              this.paymentForm.method = 'montonio';
            } else if (Const.ACTIVE_PAYMENT_GATEWAY === 'payu') {
              this.paymentForm.method = 'payu';
            }
        },
        methods: {
            changePaymentForm(form) {
                this.paymentForm.method = form;
            },
            validate() {
                let valid = true

                return valid;
            }
        }
    }
</script>

<style scoped>
    .form-error {
        font-size: 0.8rem;
        color: red;
        opacity: 0.7;
    }

    .mt-payment {
        background-color: #fff;
        padding-top: 1rem;
        border: 1px solid #e7e7e7;
    }

    .p-row {
        width: 100%;
        border: 1px solid #e2e2e2;
    }

    .p-checkbox {
        padding-left: 25px;
        padding-right: 0;
    }

    .p-checkbox input {
        width: 15px;
        height: 15px;
        appearance: none;
        background-color: #fff;
        outline: 1px solid #6c6c6c;
        border-radius: 2px;
        position: relative;
    }

    .p-checkbox input:checked {
        background: #4092e5;
        border: 2px solid #fff;
    }
</style>